import React, { useState } from "react";
import img1 from "../assets/images/background/h1.jpg";
import img2 from "../assets/images/background/h2.jpg";
import img3 from "../assets/images/background/h3.jpg";
import img4 from "../assets/images/background/h4.jpg";
import { useNavigate } from "react-router-dom";
import arrow from "../assets/images/head1-bg.png";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";

const Home = () => {
  const navigate = useNavigate();
  const [current, setCurrent] = useState("");
  const userid = localStorage.getItem("user");

  return (
    <div className="main-div">
      <Carousel
        showThumbs={false}
        showStatus={false}
        autoPlay
        infiniteLoop
        showArrows
        stopOnHover={false}
        transitionTime={4}
        onChange={(v) => setCurrent(v)}
      >
        <div
          className="carousel-img1"
          style={{
            backgroundImage: `url(${img1})`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            justifyContent: "center",
            alignItems: "end",
          }}
        >
          <h1 className={`${current == 0 && "white trans"}`}>BIGDRUM INDIA</h1>
        </div>

        <div
          className="carousel-img1"
          style={{
            backgroundImage: `url(${img2})`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            alignItems: "end",
          }}
        >
          <h1 className={`${current == 1 && "white trans1"}`}>
            Ice Cream
            <br /> Industry <span style={{ color: "red" }}>Partner</span>
          </h1>
        </div>

        <div
          className="carousel-img1"
          style={{
            backgroundImage: `url(${img4})`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            justifyContent: "center",
            alignItems: "end",
          }}
        >
          <h1 className={`${current == 2 && "white trans"}`}>
            HIGH QUALITY PRODUCTS
          </h1>
        </div>

        <div
          className="carousel-img1"
          style={{
            backgroundImage: `url(${img3})`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            alignItems: "end",
          }}
        >
          <h1 className={`${current == 3 && "white trans1"}`}>
            Serving
            <br /> Across the <span style={{ color: "red" }}>Globe</span>
          </h1>
        </div>
      </Carousel>

      <div className="div-wrapper">
        <div className="div-wrapper-inner">
          <img src={arrow} className="arrow_img mt ml" />
          <p className="mt">
            We are manufacturers of Wafer Biscuit cones or Rolled Sugar cones,
            as they are popularly known. The machinery we use is procured from
            Europe and other parts of the world. The cones and sleeves are
            automatically assembled at the assembly line, untouched by hand.
            Various tests are conducted for moisture, cone strength, top
            rounding uniformity, angle, bottom-hole absence etc., before they
            are finally packed. Even the packaging is unique at Big Drum India
            that keeps the cones in good quality and minimizes the damages in
            transit.
          </p>
          <div className="button-div mb">
            <div className="button" onClick={() => navigate("/about-us")}>
              Read More
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
//  <Swiper
//    slidesPerView={1}
//    spaceBetween={30}
//    loop={true}
//    pagination={{
//      clickable: true,
//    }}
//    navigation={true}
//    modules={[EffectFade, Autoplay, Pagination, Navigation]}
//    autoplay={{
//      delay: 2500,
//      disableOnInteraction: false,
//    }}
//  >
//    <SwiperSlide>
//      <div
//        style={{
//          height: "100%",
//          width: "100%",
//          backgroundImage: `url(${img1})`,
//          backgroundSize: "cover",
//          backgroundRepeat: "no-repeat",
//          justifyContent: "center",
//          alignItems: "end",
//          display: "flex",
//        }}
//      >
//        <h1
//          className="white trans"
//          style={{ padding: "10px", backgroundColor: "red" }}
//        >
//          BIGDRUM INDIA
//        </h1>
//      </div>
//    </SwiperSlide>
//    {/* <SwiperSlide>
//           <div
//             style={{
//               height: "100%",
//               width: "100%",
//               backgroundImage: `url(${img2})`,
//               backgroundSize: "cover",
//               backgroundRepeat: "no-repeat",
//               display: "flex",
//             }}
//           >
//             <h1 style={{ textAlign: "start", padding: "100px" }}>
//               Ice Cream
//               <br /> Industry <span style={{ color: "red" }}>Partner</span>
//             </h1>
//           </div>
//         </SwiperSlide>
//         <SwiperSlide>
//           <div
//             style={{
//               height: "100%",
//               width: "100%",
//               backgroundImage: `url(${img4})`,
//               backgroundSize: "cover",
//               backgroundRepeat: "no-repeat",
//               justifyContent: "center",
//               alignItems: "center",
//               display: "flex",
//             }}
//           >
//             <h1
//               className="white"
//               style={{ padding: "10px", backgroundColor: "red" }}
//             >
//               HIGH QUALITY PRODUCTS
//             </h1>
//           </div>
//         </SwiperSlide>
//         <SwiperSlide>
//           <div
//             style={{
//               height: "100%",
//               width: "100%",
//               backgroundImage: `url(${img3})`,
//               backgroundSize: "cover",
//               backgroundRepeat: "no-repeat",
//             }}
//           >
//             <h1 style={{ textAlign: "start", padding: "100px" }}>
//               Serving
//               <br /> Across the <span style={{ color: "red" }}>Globe</span>
//             </h1>
//           </div>
//         </SwiperSlide> */}
//  </Swiper>;
